<template>
    <el-dialog :title="`Invoice Items - ${invoiceNo}`" :visible.sync="modal" top="5vh" width="80%" @close="handleClose">
        <div class="mb-2 mt-n8">
            <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
        </div>
        <div class="mb-6">
            <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 250">
                <template #footer>
                    <v-export-table text="Export" :tableColumns="exportHeaders" :tableData="items" :filename="`InvoiceItems-${Date.now()}`" :filesheet="invoiceNo"></v-export-table>
                </template>
            </e-table>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data: ()=>({
        search: '',
        modal: false,
        headers: [],
        exportHeaders: [],
        items: [],
        invoiceNo: ''
    }),
    methods: {
        handleViewInvoiceItems(data){
            this.modal = !this.modal
            this.headers = data.headers;
            this.items = data.items
            this.exportHeaders = data.exportHeaders
            this.invoiceNo = data.invoiceNo
        },
        handleClose(){
            this.items = []
            this.search = ""
        }
    }
}
</script>